import React, { useState, Fragment } from 'react';
import { motion } from 'framer-motion';
import { PlusIcon, MinusIcon } from 'lucide-react';
interface SuperfoodsQuestionProps {
  question: string;
  answer: string;
  searchQuery?: string;
  category: string;
}
export const SuperfoodsQuestion: React.FC<SuperfoodsQuestionProps> = ({
  question,
  answer,
  searchQuery = '',
  category
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleOpen = () => setIsOpen(!isOpen);
  // Function to highlight search terms
  const highlightText = (text: string) => {
    if (!searchQuery) return text;
    const parts = text.split(new RegExp(`(${searchQuery})`, 'gi'));
    return parts.map((part, i) => part.toLowerCase() === searchQuery.toLowerCase() ? <span key={i} className="bg-green-500/30 text-white font-medium px-0.5 rounded" data-id="element-816">
          {part}
        </span> : part);
  };
  // Format the answer to preserve line breaks
  const formattedAnswer = answer.split('\n').map((line, i) => <Fragment key={i} data-id="element-817">
      {highlightText(line)}
      {i < answer.split('\n').length - 1 && <br data-id="element-818" />}
    </Fragment>);
  return <motion.div initial={{
    opacity: 0,
    y: 10
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.3
  }} className="bg-gradient-to-br from-gray-900 to-gray-800 rounded-xl overflow-hidden border border-gray-700 shadow-lg hover:shadow-xl hover:border-green-500/30 transition-all duration-300" data-id="element-819">
      <button onClick={toggleOpen} className="w-full text-left p-4 md:p-6 flex justify-between items-start" data-id="element-820">
        <div className="flex-1 pr-4" data-id="element-821">
          <div className="flex items-center mb-2" data-id="element-822">
            <div className={`text-xs font-medium px-2 py-0.5 rounded-full ${category === 'Účinky' ? 'bg-green-600/30 text-green-400' : category === 'Dávkování' ? 'bg-blue-600/30 text-blue-400' : category === 'Detoxikace' ? 'bg-purple-600/30 text-purple-400' : category === 'Nemoci' ? 'bg-orange-600/30 text-orange-400' : 'bg-green-900/30 text-green-400'}`} data-id="element-823">
              {category}
            </div>
          </div>
          <h3 className="text-lg font-semibold" data-id="element-824">{highlightText(question)}</h3>
        </div>
        <div className="flex-shrink-0 mt-1" data-id="element-825">
          {isOpen ? <div className="bg-green-500/20 p-2 rounded-full" data-id="element-826">
              <MinusIcon className="h-5 w-5 text-green-500" data-id="element-827" />
            </div> : <div className="bg-gray-800 p-2 rounded-full" data-id="element-828">
              <PlusIcon className="h-5 w-5 text-green-500" data-id="element-829" />
            </div>}
        </div>
      </button>
      <motion.div initial={false} animate={{
      height: isOpen ? 'auto' : 0,
      opacity: isOpen ? 1 : 0
    }} transition={{
      duration: 0.3
    }} className="overflow-hidden" data-id="element-830">
        {isOpen && <div className="p-4 md:p-6 pt-0 border-t border-gray-700/50 bg-black/20" data-id="element-831">
            <p className="text-gray-300 whitespace-pre-line" data-id="element-832">
              {formattedAnswer}
            </p>
          </div>}
      </motion.div>
    </motion.div>;
};